/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsTicketDto } from '../../models/as-ticket-dto';
import { CreateAsTicketDto } from '../../models/create-as-ticket-dto';

export interface AsControllerCreateClientTicket$Params {
  clientWorkspaceId: string;
      body: CreateAsTicketDto
}

export function asControllerCreateClientTicket(http: HttpClient, rootUrl: string, params: AsControllerCreateClientTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<AsTicketDto>> {
  const rb = new RequestBuilder(rootUrl, asControllerCreateClientTicket.PATH, 'post');
  if (params) {
    rb.path('clientWorkspaceId', params.clientWorkspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AsTicketDto>;
    })
  );
}

asControllerCreateClientTicket.PATH = '/api/v1/as/client/{clientWorkspaceId}/tickets';
